export type CrackingRagBandSlug = 'green' | 'amber' | 'red';

export interface CrackingRagBand {
  readonly slug: CrackingRagBandSlug;
  readonly label: string;
  readonly min: number;
  readonly max: number;
  readonly color: string;
}

/**
 * Cracking severity bands:
 * Green 0–5.99, Amber 6–10.99, Red 11–250.
 */
export const CRACKING_RAG_BANDS: readonly CrackingRagBand[] = [
  { slug: 'green', label: 'Green', min: 0, max: 5.99, color: '#65fa00' },
  { slug: 'amber', label: 'Amber', min: 6, max: 10.99, color: '#ffbc00' },
  { slug: 'red', label: 'Red', min: 11, max: 250, color: '#ff0000' },
] as const;

export const CRACKING_RAG_COLOR_SCHEME = {
  min: CRACKING_RAG_BANDS[0].color,
  max: CRACKING_RAG_BANDS[2].color,
} as const;

export const CRACKING_RAG_THRESHOLDS = [6, 11, 250] as const;

export const CRACKING_RAG_THRESHOLD_ATTRIBUTE = 'Width';

export const CRACKING_RAG_LEGEND_ITEMS = [
  { color: CRACKING_RAG_BANDS[0].color, label: '0–5.99' },
  { color: CRACKING_RAG_BANDS[1].color, label: '6–10.99' },
  { color: CRACKING_RAG_BANDS[2].color, label: '11+' },
] as const;

export function classifyCrackingValue(value: number): CrackingRagBand {
  if (!Number.isFinite(value) || value < 6) {
    return CRACKING_RAG_BANDS[0];
  }
  if (value < 11) {
    return CRACKING_RAG_BANDS[1];
  }
  return CRACKING_RAG_BANDS[2];
}
